import { useGet, usePut } from '../../../sharedModules/hooks/useQuery';
import { CollectionConfig } from '../model';

export function useCollectionConfig(location: string, enabled = true) {
  return useGet<CollectionConfig>({
    url: `/collections/configs/${location}`,
    enabled: !!location && enabled,
  });
}

export function useUpdateCollectionConfig() {
  return usePut<CollectionConfig>();
}

export function useUpdateCollectionBucket() {
  return usePut<CollectionConfig>();
}
